<template>
    <div class="d-flex-col-grow">
        <div class="d-flex" >
            <div class="page-title-section">
                <div class="page-title">{{ pageTitle }}</div>
            </div>
        </div>
        <v-divider></v-divider>
        <div class="d-flex-grow justify-center layout-gap-x py-12 bg-surface-deep-reverse">
            <div class="w-40rem max-w-100">
                <form @submit.prevent="store">
                    <v-card color="surface-reverse">
                        <v-card-text>
                            <div class="d-flex flex-column ga-5">
                                <div v-if="form.errors.custom_error" class="fs-1 pb-2 text-error">
                                    {{ form.errors.custom_error }}
                                </div>
                                <div>
                                    <v-text-field
                                        v-model="form.user_email"
                                        label="User's Email"
                                        variant="outlined"
                                        :error-messages="form.errors.user_email"
                                        required
                                    ></v-text-field>
                                </div>
                                <div>
                                    <v-text-field
                                        label="Password"
                                        v-model="form.password"
                                        ref="passwordInput"
                                        :type="passwordInputVisible ? 'text' : 'password'"
                                        placeholder="Enter your password"
                                        variant="outlined"
                                        :error-messages="form.errors.password"
                                        required
                                        class="adjust-appends"
                                    >
                                        <template #append-inner >
                                            <span role="button" @click="passwordInputVisible = !passwordInputVisible">
                                                <mdi-icon v-if="passwordInputVisible">visibility</mdi-icon>
                                                <mdi-icon v-else>visibility_off</mdi-icon>
                                            </span>
                                        </template>
                                    </v-text-field>
                                </div>
                            </div>
                        </v-card-text>
                        <v-card-actions-form>
                            <div class="d-flex flex-grow-1 justify-end">
                                <v-btn type="submit" :disabled="form.processing" :loading="form.processing">
                                    <template #prepend>
                                        <mdi-icon>check</mdi-icon>
                                    </template>
                                    <span>Log In</span>
                                </v-btn>
                            </div>
                            
                        </v-card-actions-form>
                    </v-card>
            
                </form>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { computed, ref } from "vue";
    import { useForm, usePage } from '@inertiajs/vue3';
    import { toast } from 'vue3-toastify';
    import { SharedPage, SharedPageProps } from '@/Types/inertia';
    import { SettingType, SettingTypes } from '@/Types/Models/setting';
    import helpers from '@/Plugins/helpers';
    import { pageTitle, containerGapForForm } from '@/Composables/PageMeta';
    import { useAuth } from '@/Composables/Auth';

    containerGapForForm();
    interface PageData extends SharedPageProps{
        data?:{
        }
    }

    interface Form extends SettingTypes{
        custom_error: string,
    }

    pageTitle.value = `Impersonate`;
    const page = usePage<PageData>();
    const { isSuperadmin } = useAuth();
    const passwordInputVisible = ref(false);
    const form = useForm({
        custom_error: '',
        user_email: '',
        password: ''
    });
    
    const store = () => {
        if(isSuperadmin.value){
            form.post(route('superadmin.impersonate.post'), {
                onSuccess: (page2: SharedPage) => {
                    // console.log('page onSuccess', page);
                    form.clearErrors();
                    toast.success(page2.props?.jetstream?.flash?.msg?.text ?? 'Logged in successfully');
                    window.location.href = 'dashboard';
                },
                onFinish: (visit) => {
                    // console.log('visit onFinish', visit);
                },
                onError: (errors) => {
                    console.log('onError', errors);
                }
            });
        }
    };
</script>